export const CORE_VUE = Symbol.for('CORE_VUE')
export const CORE_INITIALIZER = Symbol.for('CORE_INITIALIZER')
export const CORE_PLUGIN = Symbol.for('CORE_PLUGIN')

// runtime services
export const CORE_ROUTER = Symbol.for('CORE_ROUTER')
export const CORE_ROUTER_EXTEND = Symbol.for('CORE_ROUTER_EXTEND')
export const CORE_LOCALE = Symbol.for('CORE_LOCALE')
export const CORE_USER = Symbol.for('CORE_USER')
export const CORE_AXIOS = Symbol.for('CORE_AXIOS')
export const CORE_OAUTH = Symbol.for('CORE_OAUTH')
